import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
    apiKey: "AIzaSyAiLfIRhYQ41gLvh1BqxHINk07kDWtpg44",
    authDomain: "revlry.firebaseapp.com",
    projectId: "revlry",
    storageBucket: "revlry.firebasestorage.app",
    messagingSenderId: "588965291158",
    appId: "1:588965291158:web:4fb7719a379e7f8f380eb7",
    measurementId: "G-Q0JFFG1MK9"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export { analytics };
export const db = getFirestore(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
